import React, { useEffect } from "react";
import "./register.css";
import Logo from "../../asset/images/Logo1.png";
import { Link, useParams, useNavigate } from "react-router-dom";
import Image from "../../asset/images/image1.jpeg";
import axios from "axios";

const EmailConfirmation = () => {
    const { id } = useParams();
    const navigate = useNavigate();

    useEffect(() => {
        const handleVerification = async () => {
            try {
                const response = await axios.post(`https://teslasafebroker.com/api/email-confirmation/${id}`);
                console.log("Verification successful:", response.data);

                // ✅ Save token to localStorage
                if (response.data && response.data.token) {
                    localStorage.setItem("teslaUserAccessToken", response.data.token);
                    localStorage.setItem("teslaUserInfo", JSON.stringify(response.data.user));
                }

                // ✅ Navigate to dashboard after short delay
                setTimeout(() => {
                    navigate("/dashboard");
                }, 5000);

            } catch (error) {
                // 🌐 Detailed error handling
                if (error.response) {
                    console.error("Server responded with error:", error.response.data);

                    if (error.response.status === 500) {
                        // Internal server error
                        alert("Something went wrong, try again.");
                    } else {
                        // Other known backend errors with message
                        alert(error.response.data.message || "An error occurred.");
                    }
                } else if (error.request) {
                    console.error("No response received:", error.request);
                    alert("No response from server. Please check your connection.");
                } else {
                    console.error("Request setup error:", error.message);
                    alert("Something went wrong. Please try again.");
                }

                // ❌ Navigate back to signup page after handling error
                navigate("/signup");
            }
        };

        handleVerification();
    }, [id, navigate]);

    return (
        <div className="registration_container">
            <section className="registration image">
                <div className="style"></div>
                <div className="style"></div>
                <img src={Image} alt="register_image" />
            </section>

            <section className="registration content">
                <header className="register_header">
                    <Link to="/"><img src={Logo} alt="logo" /></Link>
                </header>

                <div className="register_body">
                    <h2>Email Confirmation</h2>
                    <p>Your account has been successfully verified and secured. You will be redirected to your dashboard shortly.</p>
                </div>
            </section>
        </div>
    );
};

export default EmailConfirmation;
